import React from "react";
import PropTypes from "prop-types";

import SiderBarMobileItem from "@/react-components/SiderBar/MobileItem";
import SiderBarMobileSubItem from "@/react-components/SiderBar/MobileSubItem";

class MobileFirstLevelMenu extends React.Component {
  render() {
    const { menuList, subMenuList, click, subItemClick } = this.props;
    return (
      <nav className="sp-menu-nav-container">
        <div className="flex-column sp-nav">
          {menuList.map((item, index) => (
            <SiderBarMobileItem
              key={index}
              item={item}
              click={() => click && click(item)}
            />
          ))}
        </div>
        <div className="sp-menu-divider" />
        <div className="flex-row-vertical-center sp-sub-nav">
          {subMenuList.map((item, index) => (
            <SiderBarMobileSubItem
              key={index}
              item={item}
              click={() => subItemClick && subItemClick(item)}
            />
          ))}
        </div>
      </nav>
    );
  }
}

MobileFirstLevelMenu.propTypes = {
  menuList: PropTypes.array.isRequired,
  subMenuList: PropTypes.array.isRequired,
  click: PropTypes.func,
  subItemClick: PropTypes.func,
};

MobileFirstLevelMenu.defaultProps = {
  click: undefined,
  subItemClick: undefined,
};

export default MobileFirstLevelMenu;
